// Pure constants & helpers extracted from Orders.jsx.
// No React, no state — safe to import anywhere.

import { Bike, Home, Luggage, Building2, Sofa } from "lucide-react";

export const sizeLabels = { small: "S", medium: "M", large: "L" };

export const sizeColors = {
  small: "bg-slate-100 text-slate-600",
  medium: "bg-orange-50 text-orange-700",
  large: "bg-red-50 text-red-600",
};

export const serviceTypes = [
  { value: "delivery", label: "Standard Delivery", icon: Bike, desc: "Regular package pickup & drop", color: "border-slate-200 bg-white" },
  { value: "room_shifting", label: "Room Shifting", icon: Home, desc: "Full room packing & move", color: "border-blue-200 bg-blue-50/30" },
  { value: "luggage_shifting", label: "Luggage Shifting", icon: Luggage, desc: "Airport/station luggage transfer", color: "border-purple-200 bg-purple-50/30" },
  { value: "office_shifting", label: "Office Shifting", icon: Building2, desc: "Office relocation with care", color: "border-emerald-200 bg-emerald-50/30" },
  { value: "small_furniture", label: "Small Furniture", icon: Sofa, desc: "Single-item furniture move", color: "border-orange-200 bg-orange-50/30" },
];

export const serviceLabels = Object.fromEntries(serviceTypes.map((s) => [s.value, s.label]));

export const vehicleLabels = { bike: "Bike", van: "Van", truck: "Truck" };

export const vehicleColors = {
  bike: "bg-slate-100 text-slate-600",
  van: "bg-blue-50 text-blue-700",
  truck: "bg-orange-50 text-[#FF6B00]",
};

export const nextActionLabel = {
  assigned: "Mark Picked",
  pickup_assigned: "Mark Picked",
  picked_up: "In Transit",
  at_micro_hub: "Out for Delivery",           // hub dispatch → last mile
  at_main_hub: "Out for Delivery",            // hub dispatch → last mile
  packing: "At Origin Hub",                   // B2B packing → origin hub
  in_transit: "Verify OTP",
  at_origin_hub: "Dispatch Linehaul",         // admin-only for hub_routed
  in_linehaul: "Arrived at Dest Hub",         // admin-only for hub_routed
  at_dest_hub: "Assign Delivery",             // admin assigns delivery agent
  out_for_delivery: "Verify OTP",
  // B2B Return statuses
  return_requested: "Assign Return Pickup",
  return_pickup_assigned: "Return Picked Up",
  return_picked_up: "Return at Hub",
  return_at_origin_hub: "Return Line-Haul",
  return_in_linehaul: "Return at Dest",
  return_at_dest_hub: "Return Delivered",
};

// Helper: derive CTA label for the booking dialog based on role + payment method.
// Admin uses the same payment flow as customers (Feb 2026), so the label
// reflects the chosen payment_method instead of always saying "Book Pickup".
export function getBookingButtonLabel(role, paymentMethod, shortForm = false) {
  if (paymentMethod === "wallet") return "Pay via Wallet";
  if (paymentMethod === "cod") return "Place Order (COD)";
  return shortForm ? "Pay & Book" : "Pay & Book Pickup";
}
